module.exports = __webpack_public_path__ + "img/pay-loading.b46c6672.png";